import React from "react";
import { useDrag } from "react-dnd";
import "../css/card.css";
import { Link } from "react-router-dom";

function Card({
  id,
  url,
  icon,
  name,
  classtype,
  description,
  onSelect,            // se presente: click = selezione/aggiunta alla pipeline
  disableLink = false, // se true non usa <Link> (niente navigazione)
  draggable = true,    // abilita/disabilita il drag
  isDisabled = false   // stato di disabilitazione
}) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "card",
    canDrag: draggable && !isDisabled,
    item: { id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const CardInner = (
    <div
      className="card"
      style={{ backgroundColor: isDragging ? "lightblue" : "white" }}
      ref={draggable && !isDisabled ? drag : null}
    >
      <img src={icon} alt="icon" className="featureIcon" />
      <h5 className={`textlinkCard textlink ${classtype}`}>{name}</h5>
      <span
        className="textCard text"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );

  // Se vogliamo bloccare la navigazione e usare il click per onSelect:
  if (onSelect || disableLink) {
    return (
      <button
        type="button"
        className="nodecoration"
        onClick={() => {
          if (isDisabled) return;
          if (onSelect) onSelect(id);
        }}
        style={{
          background: "transparent",
          border: "none",
          padding: 0,
          width: "100%",
          textAlign: "inherit",
          cursor: isDisabled ? "not-allowed" : "pointer"
        }}
        aria-disabled={isDisabled}
      >
        {CardInner}
      </button>
    );
  }

  // Comportamento standard (non usato in CreatePipeline): è un link, ma durante il drag blocchiamo il click
  const handleLinkClick = (e) => {
    if (isDragging || isDisabled) e.preventDefault();
  };

  return (
    <Link
      className="nodecoration"
      to={url}
      onClick={handleLinkClick}
    >
      {CardInner}
    </Link>
  );
}

export default Card;
